export default __webpack_public_path__ + "static/media/hiw-slide-3.e1f4185c.png";